angular.module('bmsApp.directives')
	.directive('activityFormAddon', function ($timeout) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				model: '=',
				api: '=',
				hideCustomer: '='
			},
			templateUrl: 'ng/crm/activity/directives/ActivityFormAddon/ActivityFormAddon.html',
			controller: function ($scope,
								  $q,
								  ConfigService,
								  InstanceSvc,
								  AuthService,
								  CustomerSvc,
								  EmployeeOptionsSvc,
								  ActivitySvc,
                                  ActivityTypeSvc) {


				$scope.activityFormAddonCtrl = {
					loading: true,
					options: {},
					methods: {
						init: function () {
							AuthService.getUser().then(function (user) {
								$scope.activityFormAddonCtrl.loggedInUser = user;
							});
							$scope.activityFormAddonCtrl.isSM = InstanceSvc.instance.isSM;
							// Setup config items
							$scope.activityFormAddonCtrl.config = ConfigService.config;
							$scope.activityFormAddonCtrl.datePickerConfig = angular.extend(angular.copy($scope.activityFormAddonCtrl.config.datePicker.basic), {
								options: angular.copy($scope.activityFormAddonCtrl.config.datePicker.basic.options)
							});
							$scope.activityFormAddonCtrl.datePickerConfig = angular.extend(angular.copy($scope.activityFormAddonCtrl.config.datePicker.basic), {
								storageFormat: 'YYYY-MM-DD',
								options: angular.extend(angular.copy($scope.activityFormAddonCtrl.config.datePicker.basic.options), {
									format: 'MMMM Do YYYY'
								})
							});

							$scope.activityFormAddonCtrl.methods.initWatches();

							// make sure activity model has default field
							angular.extend($scope.model, {
								// 9am-10am today
								activity_start_date: moment().hour(9).minute(0).second(0).millisecond(0),
								activity_end_date: moment().hour(10).minute(0).second(0).millisecond(0),
								mon: 0,
								tue: 0,
								wed: 0,
								thu: 0,
								fri: 0,
								sat: 0,
								sun: 0,
								reoccur_until: null,
								reoccurence_type: 'Does not repeat',
								activity_schedules: [],
								activity_type: 0
							}, $scope.model);

							// create reference to model
							$scope.activityFormAddonCtrl.activity = $scope.model;

							// fill the start and end time fields if activity already saved
							if ($scope.activityFormAddonCtrl.activity.id) {
								$scope.activityFormAddonCtrl.activity.activity_start_date = moment($scope.activityFormAddonCtrl.activity.activity_start_date);
								$scope.activityFormAddonCtrl.activity.activity_start_date_time = moment($scope.activityFormAddonCtrl.activity.activity_start_date).format('HH:mm');
								$scope.activityFormAddonCtrl.activity.activity_end_date = moment($scope.activityFormAddonCtrl.activity.activity_end_date);
								$scope.activityFormAddonCtrl.activity.activity_end_date_time = moment($scope.activityFormAddonCtrl.activity.activity_end_date).format('HH:mm');
							}

							$scope.activityFormAddonCtrl.methods.loadOptions().then(function () {
								$scope.activityFormAddonCtrl.loading = false;
							});

							// setup api
							$scope.api = {
								isActivityFilled: $scope.activityFormAddonCtrl.methods.isActivityFilled
							};

							$scope.activityTypeSelected = 0;

						},
						initWatches: function () {
							// watch the start and end dates and update each other as necessary
							$scope.$watch('activityFormAddonCtrl.activity.activity_start_date', function (newValue) {
								if (angular.isObject($scope.activityFormAddonCtrl.activity)) {
									var start = $scope.activityFormAddonCtrl.activity.activity_start_date;
									$scope.activityFormAddonCtrl.activity.activity_start_date_date = start.format($scope.activityFormAddonCtrl.datePickerConfig.storageFormat);
								}
							});

							$scope.$watch('activityFormAddonCtrl.activity.activity_end_date', function (newValue) {
								if (angular.isObject($scope.activityFormAddonCtrl.activity)) {
									var end = moment($scope.activityFormAddonCtrl.activity.activity_end_date);
									$scope.activityFormAddonCtrl.activity.activity_end_date_date = end.format($scope.activityFormAddonCtrl.datePickerConfig.storageFormat);
								}
							});
						},
						loadOptions: function () {
							var promises = {
								activityTypes: ActivityTypeSvc.index(),
								activityStatusOptions: ActivitySvc.status.options()
									.then(function (response) {
										$scope.activityFormAddonCtrl.options.activityStatus = response.data.options;
									}),
								customerOptions: CustomerSvc.options(),
								employeeOptions: EmployeeOptionsSvc.employee(),
								scheduleDurationTypeOptions: ActivitySvc.scheduleDurationTypeOptions(),
                                reoccurenceTypeOptions: ActivitySvc.reoccurenceTypeOptions()
							};
							return $q.all(promises).then(function (responses) {
                                $scope.activityFormAddonCtrl.options.activityTypes = responses.activityTypes.data.activityTypes;
                                $scope.activityFormAddonCtrl.options.customerOptions = responses.customerOptions.data.options;
								$scope.activityFormAddonCtrl.options.employeeOptions = responses.employeeOptions.data.options;
								$scope.activityFormAddonCtrl.options.scheduleDurationTypeOptions = responses.scheduleDurationTypeOptions.data.options;
								$scope.activityFormAddonCtrl.options.reoccurenceTypeOptions = responses.reoccurenceTypeOptions.data.options;
							});
						},
						updateActivityStartDate: function () {
							$timeout(function () {
								$scope.$apply(function () {
									if (angular.isObject($scope.activityFormAddonCtrl.activity)) {
										var activityStartDateDate = moment($scope.activityFormAddonCtrl.activity.activity_start_date_date);
										$scope.activityFormAddonCtrl.activity.activity_start_date.year(activityStartDateDate.year()).month(activityStartDateDate.month()).date(activityStartDateDate.date());
									}
								});
							});
						},
						updateActivityEndDate: function () {
							$timeout(function () {
								$scope.$apply(function () {
									if (angular.isObject($scope.activityFormAddonCtrl.activity)) {
										var activityEndDateDate = moment($scope.activityFormAddonCtrl.activity.activity_end_date_date);
										$scope.activityFormAddonCtrl.activity.activity_end_date.year(activityEndDateDate.year()).month(activityEndDateDate.month()).date(activityEndDateDate.date());
									}
								});
							});
						},
						reoccurenceTypeChange: function (activity) {

							if (activity.reoccurence_type === 'Does not repeat') {
								// clear recurrence date
								activity.reoccur_until = null;
							}

							if (activity.reoccurence_type === 'Weekly') {
								// reset days of week
								angular.extend(activity, {
									mon: 0,
									tue: 0,
									wed: 0,
									thu: 0,
									fri: 0,
									sat: 0,
									sun: 0
								});
							}

							if (activity.reoccurence_type === 'Monthly') {
								// reset monthly type
								activity.reoccurence_type_monthly = 'MONTH';
							}
						},
						addReminder: function () {
							$scope.activityFormAddonCtrl.activity.activity_schedules.push({});
						},
						removeReminder: function (reminder) {
							if (reminder.id) {
								reminder.delete = true;
							}
							else {
								var index = $scope.activityFormAddonCtrl.activity.activity_schedules.indexOf(reminder);
								$scope.activityFormAddonCtrl.activity.activity_schedules.splice(index, 1);
							}
						},
						isActivityFilled: function () {
							var activity = $scope.activityFormAddonCtrl.activity;
							// ignore dates, colour, repeats & reminders
							var fields = [
								(angular.isString(activity.activity_subject) && activity.activity_subject.length > 0),
								(angular.isString(activity.activity_location) && activity.activity_location.length > 0),
								(angular.isObject(activity.customer)),
								(angular.isObject(activity.employee)),
								(angular.isString(activity.activity_detail) && activity.activity_detail.length > 0)
							];
							return fields.indexOf(true) >= 0;
						}
					}
				};

				$scope.activityFormAddonCtrl.methods.init();
			}
		}
	});